import React from "react";

import {
  Table,
  TableCell,
  tableCellTypesEnum,
  tableFilterTypes,
} from "@SeemplicityDev/shared";
import { createColumnHelper } from "@tanstack/react-table";
import OrganizationActions from "./OrganizationActions";

// TODO unify: this row shape is produced by the parent CustomerProvisioning
// (orgsWithoutAccounts mapping). Define locally because the consumer is a
// parallel sibling not yet converted.
interface OrphanOrganizationRow {
  organizationSlug: string;
  organizationName: string;
  ssoEnforced: boolean;
  domains: string[];
  primaryDomain: string;
  enabled: boolean;
}

interface OrphanOrganizationsTableProps {
  loading: boolean;
  organizations: OrphanOrganizationRow[];
}

const OrphanOrganizationsTable: React.FC<OrphanOrganizationsTableProps> = ({
  loading,
  organizations,
}) => {
  const columnHelper = createColumnHelper<OrphanOrganizationRow>();

  const columns = [
    columnHelper.accessor("organizationName", {
      header: "Organization Name",
      filterFn: tableFilterTypes.TEXT.filterFn,
      meta: {
        filterType: tableFilterTypes.TEXT.filterType,
      },
    }),
    columnHelper.accessor((row) => row.domains.join(", "), {
      id: "domains",
      header: "Domains",
      filterFn: tableFilterTypes.TEXT.filterFn,
      meta: {
        filterType: tableFilterTypes.TEXT.filterType,
      },
    }),
    columnHelper.display({
      id: "actions",
      cell: (info) => (
        <TableCell
          className={"form-button-group actions-cell"}
          type={tableCellTypesEnum.COMPONENT}
        >
          <OrganizationActions
            organizationSlug={info.row?.original?.organizationSlug}
            organizationName={info.row?.original?.organizationName}
            domains={info.row?.original?.domains}
            enabled={info.row?.original?.enabled}
            compact={false}
            canDelete={info.row?.original?.enabled} // Only enabled without accounts can be deleted
          />
        </TableCell>
      ),
      header: "",
      enableColumnFilter: false,
      maxSize: 150,
      size: 150,
    }),
  ];

  return (
    <Table
      size={"large"}
      loading={loading}
      columns={columns}
      data={organizations}
      initialSortBy={[{ id: "organizationName" }]}
    />
  );
};

export default OrphanOrganizationsTable;
